/**
 * Constants for assignment text rendering and measurement.
 */

/**
 * Assignment text CSS classes - must match the actual rendered text styling.
 * Used for accurate text width measurement via canvas.
 */
export const ASSIGNMENT_TEXT_CLASSES = 'text-[10px] font-medium';

/**
 * Horizontal padding on sticky labels (px-3):
 * - Left: 12px
 * - Right: 12px
 * - Total: 24px
 */
export const STICKY_LABEL_HORIZONTAL_PADDING_PX = 24;

/**
 * Width of the DollarSignOffIcon plus its gap.
 * Icon size: 14px + gap: 2px (gap-0.5)
 */
export const NOT_BILLABLE_ICON_WIDTH_PX = 16;
